﻿import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import MembersList from './members-list'
import { IconButton, TextField } from 'material-ui';
import AddIcon from 'material-ui/svg-icons/content/add';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ListAppBar from '../core/list-app-bar';

class Members extends Component {

    constructor(props, context) {
        super(props, context);

        this.onSearchChange = this.onSearchChange.bind(this);
    }

    onSearchChange(event, value) {
        this.props.onSearch(value);
    }

    render() {

        const style = {
            color: "white"
        };

        return (
            <div>
                <ListAppBar title="Members"
                        iconElementRight={
                            <div style={{display: "inline-flex"}}>
                                <IconButton iconStyle={style}><SearchIcon /></IconButton>
                                <TextField inputStyle={style} name="SearchText" onChange={this.onSearchChange} underlineShow={true}/>
                                <IconButton iconStyle={style} href={'/member/0'}><AddIcon /></IconButton>
                            </div>
                        }
                />
                <MembersList />
            </div>
        )
    }
}

Members.contextTypes = {
    router: PropTypes.any.isRequired
};

const mapStateToProps = state => ({...state.members});

const mapDispatchToProps = dispatch => ({
    onSearch: (searchText) =>
        dispatch({type: 'SEARCH_MEMBERS', payload: searchText})
});

export default connect(mapStateToProps, mapDispatchToProps)(Members);